import Vue from "vue";
import "@/default/shares";
import Sidebar from "@/controllers/sidebar";
import Avatar from "@/default/pages/avatar.vue";
import Dropzone from "@/default/pages/dropzone.vue";
import MapAddress from "@/default/pages/maps/address.vue";
import Dashboard from "@/system/pages/dashboard.vue";

Vue.component("avatar", Avatar);
Vue.component("dropzone", Dropzone);
Vue.component("map-address", MapAddress);
Vue.component("dashboard", Dashboard);

window.Sidebar = Sidebar;
